var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHamC(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none",
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_100_2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24.6898 21.9567L3.52526 1.16791C2.86858 0.522892 1.81335 0.532341 1.16833 1.18902C0.523313 1.84569 0.532764 2.90093 1.18944 3.54595L22.354 24.3347C23.0106 24.9798 24.0659 24.9703 24.7109 24.3136C25.3559 23.657 25.3465 22.6017 24.6898 21.9567Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1.18896 21.9567L22.3535 1.16791C23.0102 0.522892 24.0654 0.532341 24.7104 1.18902C25.3554 1.84569 25.346 2.90093 24.6893 3.54595L3.52478 24.3347C2.8681 24.9798 1.81286 24.9703 1.16785 24.3136C0.522828 23.657 0.53228 22.6017 1.18896 21.9567Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_100_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamC);
export default __webpack_public_path__ + "static/media/ham-c.8ab7632d2e8f5e05abfb112d11ada71d.svg";
export { ForwardRef as ReactComponent };